export function getMessageHistoryWidth({
  selectedConversation,
  showConversationList,
  showConversationDetails,
}) {
  if (!selectedConversation) {
    return showConversationList ? "75%" : "100%";
  }

  if (showConversationList && showConversationDetails) {
    return "50%";
  }

  if (showConversationList || showConversationDetails) {
    return "75%";
  }

  return "100%";
}
